<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import { format as formatDate, isValid, parseISO } from 'date-fns'
import { computed } from 'vue'
import { cn } from '#ui-kit/lib/utils'

type DateTimeCellVariant = 'date' | 'datetime'

const props = withDefaults(
  defineProps<{
    value: string | number | Date | null | undefined
    variant?: DateTimeCellVariant
    placeholder?: string
    class?: HTMLAttributes['class']
  }>(),
  {
    variant: 'date',
  },
)

const FORMATS: Record<DateTimeCellVariant, string> = {
  date: 'MMM d, yyyy', // Jul 7, 2026
  datetime: "MMM d '-' HH:mm", // Jul 10 - 11:00
}

const date = computed(() => {
  const value = props.value
  if (value === null || value === undefined || value === '') {
    return null
  }

  const parsed = typeof value === 'number' ? new Date(value) : value instanceof Date ? value : parseISO(value)
  return isValid(parsed) ? parsed : null
})

const label = computed(() =>
  date.value ? formatDate(date.value, FORMATS[props.variant]) : (props.placeholder ?? 'N/A'),
)
</script>

<template>
  <div :class="cn('flex items-center px-2 text-xs', props.class)">
    <span :class="{ 'text-disabled/30': !date }">{{ label }}</span>
  </div>
</template>
